import React from 'react';
export var ODListableToolbarContainer = function (_a) {
    var children = _a.children;
    return React.createElement("div", { style: { display: 'flex' } }, children);
};
//# sourceMappingURL=ODListableToolbarContainer.js.map